<template>
    <div class="look longText" style="width: 100%;">
        <div>
            <el-page-header @back="close" content="系统日志"></el-page-header>
        </div>
        <div style="width: 100%;margin-top: 10px">
            <div style="width: 100%;">
                <el-descriptions class="margin-top" size="mini" border>
                    <el-descriptions-item>
                        <template slot="label">
                            操作人
                        </template>
                        {{upsertForm.adminName}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            用户操作
                        </template>
                        {{upsertForm.operation}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            响应时间
                        </template>
                        {{upsertForm.time}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            请求方法
                        </template>
                        {{upsertForm.method}}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            IP地址
                        </template>
                        {{upsertForm.ip}}
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div style="width: 100%;">
                <el-descriptions class="margin-top"  size="mini" border>
                    <el-descriptions-item>
                        <template slot="label">
                            请求参数
                        </template>
                        <json-viewer v-if="upsertForm.params" :value="upsertForm.params" :expand-depth="2" copyable sort></json-viewer>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div style="width: 100%;">
                <el-descriptions class="margin-top" size="mini" border>
                    <el-descriptions-item style="width: 300px">
                        <template slot="label">
                            响应结果
                        </template>
                        <json-viewer v-if="upsertForm.result" :value="upsertForm.result" :expand-depth="2" copyable sort></json-viewer>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import JsonViewer from "vue-json-viewer";
    export default {
        name: "lookSysLog",
        props: ['id'],
        components: {
            JsonViewer,
        },
        data(){
            return {
                upsertForm:{
                        id:'',
                        adminId:'',
                        adminName:'',
                        operation:'',
                        time:'',
                        method:'',
                        params:'',
                        ip:'',
                        result:'',
                        createTime:''
                }
            }
        },
        created(){
          axios({
                url:`${home}/sysLog/look/lookSysLogById/${this.id}`,
                method:'GET'
            }).then(res=>{
                Object.assign(this.upsertForm,res.data);
            }).catch(error=>{
                console.log(error);
            })
        },
        mounted(){

        },
        methods:{
            close(){
                this.$emit('update:visible');
            }
        }
    }
</script>

<style scoped lang="scss">
    .look{
        width:60%;
        margin: 20px 0 0 10px;
        th{
            width: 100px !important;
        }
    }
</style>
<style lang="scss">
    .longText{
        .el-descriptions__table{
            .el-descriptions-item__label{
                width: 100px !important;
            }
        }
    }

</style>